/* eslint-disable guard-for-in */
import Excel from 'exceljs';
import { saveAs } from 'file-saver';
import { isInteger } from 'lodash';

// set cloumn keys and width
const columnsKey = (items, isRevisionSummary) => {
  const columnsKeys = [];
  // eslint-disable-next-line no-restricted-syntax
  for (const key in items) {
    const defaultWidth = key.length < 50 ? 50 : key.length + 15;
    columnsKeys.push({ key, width: isRevisionSummary ? 40 : defaultWidth });
  }
  return columnsKeys;
};

/**
 * create and save excel
 * @param {object} columnsHeader
 * @param {object} itemToCell
 * @param {object} sheetHeaders
 * @param {object} others
 */
const saveExcel = async (columnsHeader, itemToCell, sheetHeaders, ...others) => {
  const workbook = new Excel.Workbook();
  const { fileName, workSheetName, isRevisionSummary } = others[0];

  try {
    // creating one worksheet in workbook
    const worksheet = workbook.addWorksheet(workSheetName, {
      properties: { tabColor: { argb: 'CCCCCC' } },
      views: [
        {
          activeCell: 'A1',
          showGridLines: false,
          zoomScale: isRevisionSummary && 90,
        },
      ],
    });

    // add worksheet columns
    // each columns contains key and its width
    worksheet.columns = columnsKey(itemToCell[0], isRevisionSummary);
    // worksheet set header values in cells
    worksheet.getRow(sheetHeaders.length / 2 + 1).values = columnsHeader;

    sheetHeaders.forEach(items => {
      worksheet.getCell(items.cell).value = items.value;
      worksheet.getCell(items.cell).font = items.font;
      worksheet.getCell(items.cell).alignment = items.alignment;
    });

    // loop through data and add each one to worksheet
    itemToCell.forEach(singleData => {
      worksheet.addRow(singleData);
    });

    // loop through all of the rows and set the outline style.
    worksheet.eachRow({ includeEmpty: false }, row => {
      const currrentRow = row;
      // store each cell to currentCell
      // eslint-disable-next-line no-underscore-dangle
      const currentCell = currrentRow._cells;

      // loop through currentCell to apply border only for the non-empty cell of excel
      currentCell.forEach(singleCell => {
        // store the cell address i.e. A1, A2, A3, B1, B2, B3, ...
        // eslint-disable-next-line no-underscore-dangle
        const cellAddress = singleCell._address;
        // apply border
        // excludeCells ['A1', 'A2', 'A3', 'B1', 'B2', 'B3'];
        if (sheetHeaders.map(item => item.cell).indexOf(cellAddress) === -1) {
          worksheet.getCell(cellAddress).border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' },
          };
          worksheet.getCell(cellAddress).font = {
            ...worksheet.getCell(cellAddress).font,
            size: 16,
          };
          if (
            !isRevisionSummary &&
            (cellAddress?.startsWith('D') || cellAddress?.startsWith('C'))
          ) {
            worksheet.getCell(cellAddress).alignment = { wrapText: true };
          }
          if (isRevisionSummary) {
            // eslint-disable-next-line no-underscore-dangle
            const approverCell = `E${singleCell?._row?._number}`;
            if (worksheet.getCell(cellAddress).value === 'Added') {
              worksheet.getCell(cellAddress).fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'c6efce' },
              };
              worksheet.getCell(cellAddress).font = { color: { argb: '006100' }, size: 16 };
              worksheet.getCell(cellAddress).alignment = { horizontal: 'center' };
              worksheet.getCell(approverCell).fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'c6efce' },
              };
              worksheet.getCell(approverCell).font = { color: { argb: '006100' }, size: 16 };
            } else if (worksheet.getCell(cellAddress).value === 'Removed') {
              worksheet.getCell(cellAddress).fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'ffc7ce' },
              };
              worksheet.getCell(cellAddress).font = { color: { argb: '9c0006' }, size: 16 };
              worksheet.getCell(cellAddress).alignment = { horizontal: 'center' };
              worksheet.getCell(approverCell).fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'ffc7ce' },
              };
              worksheet.getCell(approverCell).font = { color: { argb: '9c0006' }, size: 16 };
            }
          }
          if (isInteger(worksheet.getCell(cellAddress).value)) {
            worksheet.getCell(cellAddress).style = {
              ...worksheet.getCell(cellAddress).style,
              numFmt: '0',
            };
          }
        }

        // eslint-disable-next-line no-underscore-dangle
        if (currrentRow._number === sheetHeaders.length / 2 + 1) {
          worksheet.getCell(cellAddress).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: {
              argb: isRevisionSummary && cellAddress.startsWith('B') ? 'F2D2BD' : '445C6B',
            },
          };
          worksheet.getCell(cellAddress).font = {
            bold: true,
            size: 16,
            color: { argb: isRevisionSummary && cellAddress.startsWith('B') ? '000000' : 'FFFFFF' },
          };
        }
      });
    });

    // write the content using writeBuffer
    const buf = await workbook.xlsx.writeBuffer();

    // download the processed file
    saveAs(new Blob([buf]), `${fileName}.xlsx`);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('<<<ERRROR>>>', error);
    // eslint-disable-next-line no-console
    console.error('Something Went Wrong', error.message);
  } finally {
    // removing worksheet's instance to create new one
    workbook.removeWorksheet(workSheetName);
  }
};
export default saveExcel;
